import { useState, useEffect, useRef } from "react";
import axios from "axios";
import baseURL from "./../../../../../Url/NodeBaseURL";
import { useLocation } from "react-router-dom";
//
const useProductHandlers = () => {
  const [products, setProducts] = useState([]);
  const [data, setData] = useState([]);
  const [isQtyEditable, setIsQtyEditable] = useState(false);
  const location = useLocation();

  // Access the passed state (default to an empty object if undefined)
  const {
    order_number = "",
    mobile = "",
    advance_amt = "",
  } = location.state || {};

  const [rates, setRates] = useState({
    rate_24crt: "",
    rate_22crt: "",
    rate_18crt: "",
    rate_16crt: "",
  });
  const getTodayDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState({
    id: "",
    customer_id: "",
    mobile: mobile,
    account_name: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    pincode: "",
    state: "",
    state_code: "",
    aadhar_card: "",
    gst_in: "",
    pan_card: "",
    terms: "Cash",
    date: getTodayDate(),
    order_number: order_number,
    code: "",
    product_id: "",
    metal: "",
    product_name: "",
    metal_type: "",
    design_name: "",
    purity: "",
    selling_purity: "",
    printing_purity: "",
    pricing: "By Weight",
    pricingOpt:"Net Weight",
    category: "",
    sub_category: "",
    gross_weight: "",
    stone_weight: "",
    weight_bw: "",
    stone_price: "",
    va_on: "Gross Weight",
    va_percent: "",
    wastage_weight: "",
    total_weight_av: "",
    mc_on: "MC %",
    disscount_percentage: "",
    disscount: "",
    mc_per_gram: "",
    making_charges: "",
    rate_type: "Fixed",
    rate: "",
    // rate_24k: "",
    pieace_cost: "",
    mrp_price: "",
    rate_amt: "",
    tax_percent: "03% GST",
    tax_amt: "",
    hm_charges: "60.00",
    total_price: "",
    transaction_status: "Orders",
    qty: "1",
    opentag_id: "",
    product_image: null,
    imagePreview: null,
    remarks: "",
    sale_status: "Delivered",
    piece_taxable_amt: "",
    festival_discount: "",
    custom_purity: "",
    manual_price_update: false,
    order_status: "In Progress",
    //estimate_status: "Not Delivered",
    size: "",
    remarks_type: "",
    reservation_status: "",
    is_sales_generated: 0,
    refund_amount: null,
  });
  const [baseRate, setBaseRate] = useState(null);
  useEffect(() => {
    if (!formData.id) {
      setBaseRate(formData.rate);
    }
  }, [formData.id]);

  const [uniqueProducts, setUniqueProducts] = useState([]);
  const [metalTypes, setMetalTypes] = useState([]);
  const [purity, setPurity] = useState([]);
  const [filteredMetalTypes, setFilteredMetalTypes] = useState([]);
  const [filteredDesignOptions, setFilteredDesignOptions] = useState([]);
  const [filteredPurityOptions, setFilteredPurityOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [showWebcam, setShowWebcam] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);
  const [isTotalPriceCleared, setIsTotalPriceCleared] = useState(false);
  const [isManualTotalPriceChange, setIsManualTotalPriceChange] =
    useState(false);

  // useEffect(() => {
  //   let currentRate = "";

  //   if (formData.metal_type?.toLowerCase() === "gold" && formData.purity) {
  //     // Check if the purity value includes specific numbers
  //     if (formData.purity.includes("24")) {
  //       currentRate = rates.rate_24crt;
  //     } else if (formData.purity.includes("22")) {
  //       currentRate = rates.rate_22crt;
  //     } else if (formData.purity.includes("18")) {
  //       currentRate = rates.rate_18crt;
  //     } else if (formData.purity.includes("16")) {
  //       currentRate = rates.rate_16crt;
  //     }
  //   } else if (formData.metal_type?.toLowerCase() === "silver" && formData.purity) {
  //     currentRate = rates.silver_rate;
  //   }

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     rate: currentRate,
  //   }));
  // }, [formData.purity, formData.metal_type, rates]);

  // useEffect(() => {
  //   let currentRate = "";

  //   // Check if the metal type is explicitly silver
  //   if (formData.metal_type?.toLowerCase() === "silver" && formData.purity) {
  //     currentRate = rates.silver_rate;
  //   }
  //   // For all other cases (gold or non-gold/non-silver), use gold rates
  //   else if (formData.purity) {
  //     if (formData.purity.includes("24")) {
  //       currentRate = rates.rate_24crt;
  //     } else if (formData.purity.includes("22")) {
  //       currentRate = rates.rate_22crt;
  //     } else if (formData.purity.includes("18")) {
  //       currentRate = rates.rate_18crt;
  //     } else if (formData.purity.includes("16")) {
  //       currentRate = rates.rate_16crt;
  //     }
  //   }

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     rate: currentRate,
  //   }));
  // }, [formData.purity, formData.metal_type, rates]);

  useEffect(() => {
    const fetchCurrentRates = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/current-rates`);
        setRates({
          rate_24crt: response.data.rate_24crt || "",
          rate_22crt: response.data.rate_22crt || "",
          rate_18crt: response.data.rate_18crt || "",
          rate_16crt: response.data.rate_16crt || "",
          silver_rate: response.data.silver_rate || "",
        });
        const metalType = formData.metal_type?.toLowerCase();

        setFormData((prev) => ({
          ...prev,
          rate_24k:
            metalType === "silver" ? rates.silver_rate : rates.rate_24crt,
        }));
      } catch (error) {
        console.error("Error fetching current rates:", error);
      }
    };

    fetchCurrentRates();
  }, [formData.metal_type]);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${baseURL}/get/products`);
      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }
      const result = await response.json();
      setProducts(result);
      console.log("Products=", result);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchTags = async () => {
    try {
      const response = await fetch(`${baseURL}/get/opening-tags-entry`);
      if (!response.ok) {
        throw new Error("Failed to fetch tags");
      }
      const result = await response.json();
      // const availableTags = result.result.filter(
      //   (tag) => tag.Status === "Available"
      // );
      setData(result.result); // set only 'Available' tags
      // setData(result.result);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchTags();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "total_price") {
      setIsManualTotalPriceChange(true);
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Preserve the current barcode
    const currentBarcode = formData.code;

    let updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Handle metal type changes specifically
    if (name === "metal_type") {
      const lowerValue = value.toLowerCase();
      const prevMetalLower = formData.metal_type?.toLowerCase();

      // When changing from silver to gold/non-silver
      if (prevMetalLower === "silver" && lowerValue !== "silver") {
        updatedFormData = {
          ...updatedFormData,
          mc_on: "MC %", // Switch to MC%
          mc_per_gram: "", // Clear MC per gram
          making_charges: "", // Clear making charges
        };
      }
      // When changing from gold/non-silver to silver
      else if (prevMetalLower !== "silver" && lowerValue === "silver") {
        updatedFormData = {
          ...updatedFormData,
          mc_on: "MC / Gram", // Switch to MC/Gram
          mc_per_gram: "", // Clear MC per gram
          making_charges: "", // Clear making charges
        }; //
      }
    }

    // Handle selling_purity changes
    if (name === "selling_purity") {
      if (value === "") {
        // Clear fields when "Select Purity" is chosen
        setFormData((prev) => ({
          ...prev,
          selling_purity: "",
          custom_purity: "",
          rate: "",
        }));
        setBaseRate("");
        return;
      } else if (value === "Manual") {
        updatedFormData.rate = "";
      } else {
        // Calculate rate for any purity value
        const purityValue = parseFloat(value);
        if (!isNaN(purityValue) && formData.rate_24k) {
          const baseRate = parseFloat(formData.rate_24k);
          const base = ((purityValue / 100) * baseRate).toFixed(2);
          updatedFormData.rate = base;
          setBaseRate(base);
        }
      }
    }

    if (name === "product_name") {
      if (value === "") {
        updatedFormData.selling_purity = "";
        updatedFormData.purity = "";
        updatedFormData.printing_purity = "";
        updatedFormData.pricing = "By Weight"; // Reset pricing when sub category is cleared
        updatedFormData.rate = "";
        setBaseRate("");
      } else {
        const selectedSubCategory = subcategoryOptions.find(
          (option) => option.value === value
        );

        if (selectedSubCategory) {
          updatedFormData.selling_purity =
            selectedSubCategory.selling_purity || "";
          updatedFormData.purity = selectedSubCategory.purity || "";
          updatedFormData.printing_purity =
            selectedSubCategory.printing_purity || "";
          updatedFormData.pricingOpt= selectedSubCategory.pricingOpt || "";

          // Set pricing based on sub category
          updatedFormData.pricing = selectedSubCategory.pricing || "By Weight";

          const purityValue = parseFloat(selectedSubCategory.selling_purity);
          const baseRate = parseFloat(formData.rate_24k) || 0;
          if (!isNaN(purityValue)) {
            const base = ((purityValue / 100) * baseRate).toFixed(2);
            updatedFormData.rate = base;
            setBaseRate(base);
          }
        }
      }
    }

    if (name === "custom_purity" && formData.selling_purity === "Manual") {
      if (value === "") {
        // Clear rate when custom purity is cleared
        updatedFormData.rate = "";
      } else {
        const purityValue = parseFloat(value);
        const baseRate = parseFloat(formData.rate_24k) || 0;
        if (!isNaN(purityValue)) {
          const base = ((purityValue / 100) * baseRate).toFixed(2);
            updatedFormData.rate = base;
            setBaseRate(base);
        }
      }
    }

    if (name === "category") {
      // Find the first product that matches this category
      const categoryProduct = products.find(
        (prod) => prod.product_name === value
      );

      if (categoryProduct) {
        updatedFormData = {
          ...updatedFormData,
          code: categoryProduct.rbarcode || "",
          product_id: categoryProduct.product_id || "",
          metal_type: categoryProduct.Category || "",
          selling_purity: "",
          product_name: "",
          rate: "",
        };
        setBaseRate("");

        // Add this to set mc_on to "MC / Gram" if category is silver
        if (categoryProduct.Category?.toLowerCase() === "silver") {
          updatedFormData.mc_on = "MC / Gram";
        }
      } else {
        updatedFormData = {
          ...updatedFormData,
          code: "",
          product_id: "",
          metal_type: "",
        };
      }
    }

    if (name === "category" && value === "") {
      updatedFormData = {
        ...updatedFormData, // Keep other existing values
        code: "",
        product_id: "",
        metal: "",
        product_name: "",
        metal_type: "",
        design_name: "",
        purity: "",
        pricing: "",
        category: "",
        sub_category: "",
        gross_weight: "",
        stone_weight: "",
        weight_bw: "",
        stone_price: "",
        va_on: "Gross Weight",
        va_percent: "",
        wastage_weight: "",
        total_weight_av: "",
        mc_on: "MC %",
        disscount_percentage: "",
        disscount: "",
        mc_per_gram: "",
        making_charges: "",
        rate: "",
        pieace_cost: "",
        rate_amt: "",
        tax_percent: "03% GST",
        tax_amt: "",
        hm_charges: "60.00",
        total_price: "",
        transaction_status: "Orders",
        qty: "1",
        opentag_id: "",
        product_image: null,
        imagePreview: null,
        remarks: "",
        size: "",
      };
    }

    if (name === "mc_on") {
      if (value !== formData.mc_on) {
        // Reset values only when changing from the tag's initial value
        if (!formData.isTagSelected) {
          updatedFormData.mc_per_gram = "0";
          updatedFormData.making_charges = "0";
        } else {
          updatedFormData.mc_per_gram = formData.mc_per_gram; // Keep previous value
          updatedFormData.making_charges = formData.making_charges; // Keep previous value
        }
      }
    }

    if (name === "purity" || name === "metal_type") {
      // Separate condition for gold
      if (formData.metal_type.toLowerCase() === "gold") {
        // Check for different purity values and set the rate accordingly for gold
        if (
          value.toLowerCase().includes("22") || // Check for 22 KT, 22K, 22k, etc.
          value.toLowerCase().includes("22kt") ||
          value.toLowerCase().includes("22k")
        ) {
          updatedFormData.rate = rates.rate_22crt;
        } else if (
          value.toLowerCase().includes("24") || // Check for 24 KT, 24K, etc.
          value.toLowerCase().includes("24kt") ||
          value.toLowerCase().includes("24k")
        ) {
          updatedFormData.rate = rates.rate_24crt;
        } else if (
          value.toLowerCase().includes("18") || // Check for 18 KT, 18K, etc.
          value.toLowerCase().includes("18kt") ||
          value.toLowerCase().includes("18k")
        ) {
          updatedFormData.rate = rates.rate_18crt;
        } else if (
          value.toLowerCase().includes("16") || // Check for 16 KT, 16K, etc.
          value.toLowerCase().includes("16kt") ||
          value.toLowerCase().includes("16k")
        ) {
          updatedFormData.rate = rates.rate_16crt;
        } else {
          updatedFormData.rate = "";
        }
      }
    }

    // Trigger recalculation for Total MC if relevant fields are updated
    if (
      formData.metal_type?.toLowerCase() === "gold" &&
      (name === "mc_per_gram" || name === "rate_amt")
    ) {
      const mcPercentage =
        parseFloat(name === "mc_per_gram" ? value : formData.mc_per_gram) || 0;
      const rateAmount =
        parseFloat(name === "rate_amt" ? value : formData.rate_amt) || 0;

      const totalMC = (mcPercentage / 100) * rateAmount;
      setFormData((prevData) => ({
        ...prevData,
        making_charges: totalMC.toFixed(2),
      }));
    }

    // Handle discount calculation
    if (name === "disscount_percentage") {
      const discountPercentage = parseFloat(value) || 0;
      const makingCharges = parseFloat(formData.making_charges) || 0;
      const discountAmount = (discountPercentage / 100) * makingCharges;

      updatedFormData.disscount = discountAmount.toFixed(2);
    }
    if (name === "selling_purity") {
      updatedFormData.purity = value === "Manual" ? "Manual" : value;
    }
    // if (name === "rate_type") {
    //   updatedFormData.rate_type = value;
    // }
    if (name === "rate_type" && !formData.id) {
      if (value === "Fixed") {
        updatedFormData.rate = baseRate;
      }
    }
    if (formData.pricing === "By Running Tag") {
      const pieceCost = parseFloat(updatedFormData.pieace_cost) || 0;
      const quantity = parseFloat(updatedFormData.qty) || 1;

      updatedFormData.rate_amt = (pieceCost * quantity).toFixed(2);
    }

    setFormData(updatedFormData);
  };

  const handleProductNameChange = (productName) => {
    const productEntries = data.filter(
      (prod) => prod.sub_category === productName
    );

    if (productEntries.length > 0) {
      const uniqueMetalTypes = Array.from(
        new Set(productEntries.map((prod) => prod.metal_type))
      ).map((metalType) => ({ metal_type: metalType }));

      setFormData((prevData) => ({
        ...prevData,
        product_name: productName,
        metal_type: "",
        design_name: "",
      }));

      setFilteredMetalTypes(uniqueMetalTypes); // Update metal types based on selected product
      setFilteredDesignOptions([]); // Clear design options initially
    } else {
      // Reset fields if no matching product entries found
      setFormData((prevData) => ({
        ...prevData,
        code: "",
        product_name: "",
        metal_type: "",
        design_name: "",
        purity: "",
        category: "",
        sub_category: "",
        gross_weight: "",
        stone_weight: "",
        stone_price: "",
        weight_bw: "",
        va_on: "",
        va_percent: "",
        wastage_weight: "",
        total_weight_aw: "",
        mc_on: "",
        mc_per_gram: "",
        making_charges: "",
        disscount_percentage: "",
        disscount: "",
        rate: "",
        rate_amt: "",
        tax_percent: "",
        tax_amt: "",
        hm_charges: "60.00",
        total_price: "",
        qty: "",
        remarks: "",
        size: "",
      }));

      setFilteredMetalTypes(metalTypes);
      setFilteredDesignOptions(designOptions);
    }
  };

  const handleMetalTypeChange = (metalType) => {
    const productEntries = data.filter(
      (prod) =>
        prod.sub_category === formData.product_name &&
        prod.metal_type === metalType
    );

    if (productEntries.length > 0) {
      const uniqueDesignOptions = Array.from(
        new Set(productEntries.map((prod) => prod.design_master))
      ).map((designMaster) => ({ design_master: designMaster }));

      setFormData((prevData) => ({
        ...prevData,
        metal_type: metalType,
        design_name: "",
      }));

      setFilteredDesignOptions(uniqueDesignOptions); // Update design options based on metal type
    } else {
      // Reset if no matching entries found
      setFormData((prevData) => ({
        ...prevData,
        metal_type: "",
        design_name: "",
      }));

      setFilteredDesignOptions([]);
    }
  };

  const handleDesignNameChange = (designName) => {
    const productEntries = data.filter(
      (prod) =>
        prod.sub_category === formData.product_name &&
        prod.metal_type === formData.metal_type &&
        prod.design_master === designName
    );

    if (productEntries.length > 0) {
      const uniquePurityOptions = Array.from(
        new Set(productEntries.map((prod) => prod.Purity))
      ).map((Purity) => ({ Purity }));

      setFormData((prevData) => ({
        ...prevData,
        design_name: designName,
        purity: "",
      }));

      setFilteredPurityOptions(uniquePurityOptions); // Update purity options based on design
    } else {
      setFormData((prevData) => ({
        ...prevData,
        design_name: "",
        purity: "",
      }));

      setFilteredPurityOptions([]);
    }
  };

  const [isBarcodeSelected, setIsBarcodeSelected] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [metaltypeOptions, setMetaltypeOptions] = useState([]);
  const [purityOptions, setpurityOptions] = useState([]);
  const [designOptions, setDesignOptions] = useState([]);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await fetch(`${baseURL}/get/products`);
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const result = await response.json();
        if (result && Array.isArray(result)) {
          const formattedOptions = result.map((item) => ({
            label: item.product_name, // Display name
            value: item.product_name, // Unique value
          }));
          setCategoryOptions(formattedOptions);
        } else {
          console.error("Invalid API response format", result);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCategory();
  }, []);

  useEffect(() => {
    const fetchSubCategory = async () => {
      try {
        const response = await fetch(`${baseURL}/subcategory`); // Use the correct API endpoint
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();
        if (result && result.data) {
          // If formData.metal_type is available, filter based on it, otherwise show all
          const filteredData = formData.category
            ? result.data.filter((item) => item.category === formData.category)
            : result.data;

          // Format the filtered options
          const formattedOptions = filteredData.map((item) => ({
            label: item.sub_category_name, // Display value
            value: item.sub_category_name, // Unique ID for value
            selling_purity: item.selling_purity,
            printing_purity: item.printing_purity,
            purity: item.purity,
            pricing: item.pricing,
            pricingOpt:item.pricingOpt,
          }));

          setSubcategoryOptions(formattedOptions);
        } else {
          console.error("Invalid API response format", result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Run the function initially and when formData.metal_type changes
    fetchSubCategory();
  }, [formData.category]);

  const [allMetalTypes, setAllMetalTypes] = useState([]);

  useEffect(() => {
    const fetchMetalType = async () => {
      try {
        const response = await fetch(`${baseURL}/metaltype`);
        const data = await response.json();

        // Extract all metal types
        const allMetalTypes = Array.from(
          new Set(data.map((product) => product.metal_name))
        );

        // Store all metal types
        setAllMetalTypes(allMetalTypes);

        // Initially, show all metal types
        setMetaltypeOptions(
          allMetalTypes.map((category) => ({
            value: category,
            label: category,
          }))
        );
      } catch (error) {
        console.error("Error fetching metal types:", error);
      }
    };

    fetchMetalType();
  }, []);

  useEffect(() => {
    if (!formData.category) {
      // Show all metal types if no category is selected
      setMetaltypeOptions(
        allMetalTypes.map((category) => ({
          value: category,
          label: category,
        }))
      );
      return;
    }

    const fetchFilteredMetalTypes = async () => {
      try {
        const response = await fetch(`${baseURL}/get/products`);
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const result = await response.json();

        // Find selected category object
        const selectedProduct = result.find(
          (item) => item.product_name === formData.category
        );

        if (selectedProduct) {
          const filteredMetals = allMetalTypes.filter(
            (metal) => metal === selectedProduct.Category
          );

          const options = filteredMetals.map((category) => ({
            value: category,
            label: category,
          }));

          setMetaltypeOptions(options);

          // Auto-select the first option only when a category is selected
          if (formData.category && options.length > 0) {
            setFormData((prev) => ({ ...prev, metal_type: options[0].value }));
          }
        }
      } catch (error) {
        console.error("Error fetching filtered metal types:", error);
      }
    };

    fetchFilteredMetalTypes();
  }, [formData.category, allMetalTypes]);

  useEffect(() => {
    const fetchDesignName = async () => {
      try {
        const response = await fetch(`${baseURL}/designmaster`);
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const result = await response.json();
        if (result && Array.isArray(result)) {
          const formattedOptions = result.map((item) => ({
            label: item.design_name, // Display name
            value: item.design_name, // Unique value
          }));
          setDesignOptions(formattedOptions);
        } else {
          console.error("Invalid API response format", result);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchDesignName();
  }, []);

  useEffect(() => {
    const fetchPurity = async () => {
      try {
        const response = await fetch(`${baseURL}/purity`);
        const data = await response.json();

        let filteredData = data;

        // If metal_type is explicitly silver, filter for silver
        if (formData.metal_type?.toLowerCase() === "silver") {
          filteredData = data.filter(
            (product) => product.metal?.toLowerCase() === "silver"
          );
        }
        // For all other cases (gold or non-gold/non-silver), use gold purity options
        else {
          filteredData = data.filter(
            (product) => product.metal?.toLowerCase() === "gold"
          );
        }

        const purities = Array.from(
          new Set(
            filteredData.map((product) => `${product.name} | ${product.purity}`)
          )
        );

        const purityOptions = purities.map((purity) => ({
          value: purity,
          label: purity,
        }));

        setpurityOptions(purityOptions);

        // Set default purity (22k) for gold or non-silver cases
        if (
          formData.metal_type?.toLowerCase() !== "silver" &&
          purityOptions.length > 0
        ) {
          const defaultPurity = purityOptions.find((option) =>
            /22/i.test(option.value)
          )?.value;

          setFormData((prevData) => ({
            ...prevData,
            purity: defaultPurity || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchPurity();
  }, [formData.metal_type]);

  const handleBarcodeChange = async (code) => {
    try {
      if (!code) {
        // If barcode is cleared, reset all related fields
        setIsBarcodeSelected(false);
        setFormData((prevData) => ({
          ...prevData,
          code: "",
          product_id: "",
          product_name: "",
          metal_type: "",
          design_name: "",
          purity: "",
          category: "",
          sub_category: "",
          gross_weight: "",
          stone_weight: "",
          stone_price: "",
          weight_bw: "",
          va_on: "Gross Weight",
          va_percent: "",
          wastage_weight: "",
          total_weight_aw: "",
          mc_on: "MC %", // Reset to default MC%
          mc_per_gram: "",
          making_charges: "",
          disscount_percentage: "",
          disscount: "",
          rate: "",
          rate_amt: "",
          tax_percent: "",
          tax_amt: "",
          hm_charges: "60.00",
          total_price: "",
          qty: "",
          remarks: "",
          size: "",
          opentag_id: "", // Clear opentag_id when barcode is cleared
        }));
        setIsQtyEditable(true);
        return;
      }

      // Check for product by code
      const product = products.find(
        (prod) => String(prod.rbarcode) === String(code)
      );
      if (product) {
        setIsBarcodeSelected(true);
        const isSilver = product.Category?.toLowerCase() === "silver";

        // Set default purity (22k for gold, empty for silver)
        const defaultPurity = isSilver
          ? ""
          : purityOptions.find((option) => /22/i.test(option.value))?.value;

        setFormData((prevData) => ({
          ...prevData,
          code: product.rbarcode,
          product_id: product.product_id,
          product_name: "",
          metal_type: product.Category,
          design_name: "",
          purity: defaultPurity || "",
          category: product.product_name,
          sub_category: "",
          gross_weight: "",
          stone_weight: "",
          stone_price: "",
          weight_bw: "",
          va_on: "Gross Weight",
          va_percent: "",
          wastage_weight: "",
          total_weight_aw: "",
          mc_on: isSilver ? "MC / Gram" : "MC %", // Auto-set based on metal type
          mc_per_gram: isSilver ? prevData.mc_per_gram : "", // Clear if not silver
          making_charges: isSilver ? prevData.making_charges : "", // Clear if not silver
          disscount_percentage: "",
          disscount: "",
          tax_percent: product.tax_slab,
          qty: 1,
          opentag_id: "", // Clear opentag_id when switching to normal product
        }));
        setIsQtyEditable(false);
      } else {
        // Check if tag exists by code
        const tag = data.find(
          (tag) => String(tag.PCode_BarCode) === String(code)
        );        
        if (tag) {
          const isSilver = tag.metal_type?.toLowerCase() === "silver";
          const productId = tag.product_id;
          const productDetails = products.find(
            (prod) => String(prod.product_id) === String(productId)
          );
          if (
            tag.Status === "Sold" ||
            tag.Status === "Sale Returned" ||
            tag.Status === "Reserved"
          ) {
            alert("The product is already sold out!");
            return;
          }

          const tagPricing = tag.Pricing || formData.pricing || "By Weight";
          const parsePercent = (val) => {
            if (val === null || val === undefined || val === "") return 0;
            const s = val.toString().replace("%", "").trim();
            const n = Number(s);
            return Number.isFinite(n) ? n : 0;
          };

          // Fetch purchase record using tag's invoice number to get actual purchase values
          let purchaseRecord = null;
          if (tag.invoice) {
            try {
              const purchaseResponse = await axios.get(`${baseURL}/get-purchase-details/${tag.invoice}`);
              const purchaseData = purchaseResponse.data?.repeatedData || [];
              
              // Find the specific product in the purchase record that matches this tag
              purchaseRecord = purchaseData.find(
                (item) => String(item.product_id) === String(tag.product_id)
              );
            } catch (error) {
              console.error("Error fetching purchase record:", error);
            }
          }

          // Fetch subcategory details to get selling addon values
          let subcategoryData = null;
          try {
            const subcategoryResponse = await axios.get(`${baseURL}/get/subcategories`);
            subcategoryData = subcategoryResponse.data.find(
              (sub) => sub.sub_category_name === tag.sub_category
            );
          } catch (error) {
            console.error("Error fetching subcategory details:", error);
          }

          // For "By Running Tag", calculate combined values (Purchase + Selling Addon)
          let combinedPurity = "";
          let combinedWastage = "";
          let combinedMC = "";
          
          if (tagPricing === "By Running Tag") {
            // Get purchase values from purchase record (fetched by invoice), not tag
            let purchasePurity = 0;
            if (purchaseRecord) {
              // Use purchase record values
              if (purchaseRecord.Purity && String(purchaseRecord.Purity).toLowerCase().includes("manual")) {
                purchasePurity = parsePercent(purchaseRecord.purityPercentage || "");
              } else {
                purchasePurity = parsePercent(purchaseRecord.Purity || purchaseRecord.purityPercentage || "");
              }
            } else {
              // Fallback to tag values if purchase record not found
              if (tag.pur_Purity && String(tag.pur_Purity).toLowerCase().includes("manual")) {
                purchasePurity = parsePercent(tag.pur_purityPercentage || tag.purityPercentage || "");
              } else {
                purchasePurity = parsePercent(tag.pur_Purity || tag.pur_purityPercentage || tag.purityPercentage || "");
              }
            }
            
            const purchaseWastage = purchaseRecord 
              ? parsePercent(purchaseRecord.wastage || "")
              : parsePercent(tag.pur_Wastage_Percentage || "");
            
            // Get purchase MC - only if MC On is "MC %"
            let purchaseMC = 0;
            const mcOnValue = purchaseRecord?.Making_Charges_On || tag.pur_Making_Charges_On || "";
            if (mcOnValue === "MC %") {
              purchaseMC = purchaseRecord
                ? parsePercent(purchaseRecord.Making_Charges_Value || "")
                : parsePercent(tag.pur_MC_Per_Gram || "");
            }
            
            // Get selling addon values from subcategory
            const sellingAddonPurity = parsePercent(
              subcategoryData?.selling_addon_purity || 
              tag.selling_addon_purity || 
              ""
            );
            const sellingAddonWastage = parsePercent(
              subcategoryData?.selling_addon_wastage_percent || 
              tag.selling_addon_wastage_percent || 
              ""
            );
            const sellingAddonMC = parsePercent(
              subcategoryData?.selling_addon_mc_percent || 
              tag.selling_addon_mc_percent || 
              ""
            );
            
            // Calculate combined values
            // Selling Purity = Purchase Purity + Selling Addon Purity only (MC and Wastage shown separately)
            const totalPurity = purchasePurity + sellingAddonPurity;
            const totalWastage = purchaseWastage + sellingAddonWastage;
            const totalMC = purchaseMC + sellingAddonMC;
            
            // Format for display
            combinedPurity = totalPurity > 0 ? totalPurity.toFixed(2) : "";
            combinedWastage = totalWastage > 0 ? totalWastage.toFixed(2) : "";
            combinedMC = totalMC > 0 ? totalMC.toFixed(2) : "";
          }

          // Get purchase values for formData storage
          let purchasePurityValue = "";
          let purchaseWastageValue = "";
          let purchaseMCValue = "";
          let purchaseMcOnValue = "";
          
          if (tagPricing === "By Running Tag") {
            // Get purchase purity from purchase record, then tag
            if (purchaseRecord?.Purity && String(purchaseRecord.Purity).toLowerCase().includes("manual")) {
              purchasePurityValue = purchaseRecord.purityPercentage || "";
            } else if (purchaseRecord?.Purity) {
              purchasePurityValue = purchaseRecord.Purity;
            } else if (purchaseRecord?.purityPercentage) {
              purchasePurityValue = purchaseRecord.purityPercentage;
            } else if (tag.pur_Purity && String(tag.pur_Purity).toLowerCase().includes("manual")) {
              purchasePurityValue = tag.pur_purityPercentage || tag.purityPercentage || "";
            } else {
              purchasePurityValue = tag.pur_Purity || tag.pur_purityPercentage || tag.purityPercentage || "";
            }

            // Get purchase wastage from purchase record, then tag
            purchaseWastageValue = purchaseRecord?.wastage || tag.pur_Wastage_Percentage || "";

            // Get purchase MC from purchase record, then tag
            purchaseMcOnValue = purchaseRecord?.Making_Charges_On || tag.pur_Making_Charges_On || "";
            if (purchaseMcOnValue === "MC %") {
              purchaseMCValue = purchaseRecord?.Making_Charges_Value || tag.pur_MC_Per_Gram || "";
            }
          }

          setFormData((prevData) => ({
            ...prevData,
            code: tag.PCode_BarCode || "",
            product_id: tag.product_id || "",
            opentag_id: tag.opentag_id || "",
            product_name: tag.sub_category || "",
            metal_type: tag.metal_type || "",
            design_name: tag.design_master || "",
            // For "By Running Tag", use combined purity (Purchase + Selling Addon), otherwise use tag value
            purity: tagPricing === "By Running Tag" && combinedPurity 
              ? combinedPurity 
              : (tag.Purity || ""),
            category: tag.category || "",
            sub_category: tag.sub_category || "",
            gross_weight: tag.Gross_Weight || "",
            stone_weight: tag.Stones_Weight || "",
            stone_price: tag.Stones_Price || "",
            weight_bw: tag.Weight_BW || "",
            va_on: tag.Wastage_On || "Gross Weight",
            // For "By Running Tag", use combined wastage (Purchase + Selling Addon), otherwise use tag value
            va_percent: tagPricing === "By Running Tag" && combinedWastage 
              ? combinedWastage 
              : (tag.Wastage_Percentage || ""),
            wastage_weight: tag.WastageWeight || "",
            total_weight_aw: tag.TotalWeight_AW || "",
            // For "By Running Tag", use purchase record's MC On and combined MC (Purchase + Selling Addon)
            mc_on: tagPricing === "By Running Tag" 
              ? (purchaseMcOnValue || "MC %")
              : (isSilver ? "MC / Gram" : tag.Making_Charges_On || "MC %"),
            // For "By Running Tag", MC % should be the combined value (Purchase MC + Selling Addon MC)
            mc_per_gram: tagPricing === "By Running Tag" && combinedMC 
              ? combinedMC 
              : (isSilver ? tag.MC_Per_Gram || "" : ""),
            making_charges: isSilver ? tag.Making_Charges || "" : "",
            tax_percent: productDetails?.tax_slab || "",
            qty: 1,
            pricing: tagPricing,
            pieace_cost: tag.pieace_cost || "",
            // Store purchase values in formData for calculateSellingPurityForRunningTag
            pur_Purity: purchasePurityValue,
            pur_purityPercentage: purchasePurityValue,
            pur_Wastage_Percentage: purchaseWastageValue,
            pur_MC_Per_Gram: purchaseMCValue,
            pur_Making_Charges_On: purchaseMcOnValue,
            // Store selling addon values in formData
            selling_addon_purity: subcategoryData?.selling_addon_purity || tag.selling_addon_purity || "",
            selling_addon_mc_percent: subcategoryData?.selling_addon_mc_percent || tag.selling_addon_mc_percent || "",
            selling_addon_wastage_percent: subcategoryData?.selling_addon_wastage_percent || tag.selling_addon_wastage_percent || "",
          }));
          setIsQtyEditable(true);
        } else {
          // No matching product or tag found - reset form
          setFormData((prevData) => ({
            ...prevData,
            code: "",
            product_id: "",
            product_name: "",
            metal_type: "",
            design_name: "",
            purity: "",
            category: "",
            sub_category: "",
            gross_weight: "",
            stone_weight: "",
            stone_price: "",
            weight_bw: "",
            va_on: "Gross Weight",
            va_percent: "",
            wastage_weight: "",
            total_weight_aw: "",
            mc_on: "MC %", // Default to MC%
            mc_per_gram: "",
            making_charges: "",
            disscount_percentage: "",
            disscount: "",
            rate: "",
            rate_amt: "",
            tax_percent: "",
            tax_amt: "",
            hm_charges: "60.00",
            total_price: "",
            qty: "",
            remarks: "",
            size: "",
          }));
          setIsQtyEditable(true);
        }
      }
    } catch (error) {
      console.error("Error handling barcode change:", error);
    }
  };

  const [image, setImage] = useState(null);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({ ...prev, imagePreview: reader.result }));
      };
      reader.readAsDataURL(file);
      setShowOptions(false); // Hide options after selection
    }
  };

  const clearImage = () => {
    setFormData((prev) => ({ ...prev, imagePreview: null }));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setFormData((prev) => ({ ...prev, imagePreview: imageSrc }));
      setShowWebcam(false);
      setShowOptions(false); // Hide options after capturing
    }
  };

  return {
    formData,
    data,
    setFormData,
    products,
    isQtyEditable,
    handleChange,
    handleImageChange,
    fileInputRef,
    clearImage,
    captureImage,
    setShowWebcam,
    showWebcam,
    webcamRef,
    setShowOptions,
    showOptions,
    image,
    handleBarcodeChange,
    handleProductNameChange,
    handleMetalTypeChange,
    handleDesignNameChange,
    filteredDesignOptions,
    filteredPurityOptions,
    filteredMetalTypes,
    categoryOptions,
    subcategoryOptions,
    designOptions,
    purityOptions,
    metaltypeOptions,
    uniqueProducts,
    isBarcodeSelected,
    advance_amt,
    isManualTotalPriceChange,
    setIsManualTotalPriceChange,
    isTotalPriceCleared,
    setIsTotalPriceCleared,
  };
};

export default useProductHandlers;
